var fList = [...document.querySelectorAll('.fixed__content')];
var exitCard = document.querySelector('.exit_card');

var f_options = {
  rootMargin: '-40% 0% -60% 0%',
  threshold: 0.0
}

let f_observer = new IntersectionObserver(f_reveal, f_options);

function f_reveal(blocks){
  blocks.forEach((block, i) => {
    block.target.children[0].classList.toggle("animate-in", block.isIntersecting)
  })  
}

const lastCardObserver = new IntersectionObserver(entries => {
  const lastCard = entries[0]
  exitCard.classList.toggle("exit-animation", lastCard.isIntersecting)
}, {threshold: 0.5})

fList.forEach(item =>{
 f_observer.observe(item); 
})



//ORIGINAL

/*

var fList = [...document.querySelectorAll('.fixed__content')];
var exitCard = document.querySelector('.exit_card');

var f_options = {
  rootMargin: '-40% 0% -60% 0%',
  threshold: 0.0
}

let f_observer = new IntersectionObserver(f_reveal, f_options);

function f_reveal(blocks){
  blocks.forEach((block, i) => {
    block.target.children[0].classList.toggle("animate-in", block.isIntersecting)
  })  
}

const lastCardObserver = new IntersectionObserver(entries => {
  const lastCard = entries[0]
  exitCard.classList.toggle("exit-animation", lastCard.isIntersecting)
}, {threshold: 0.5})

fList.forEach(item =>{
 f_observer.observe(item); 
})

*/